<template>
  <div class="detailed-mode-explanation-root">
    <div class="definition">{{indicatorItem.resource.Definition}}</div>
    <div class="advice" v-if="this.isInOverflow">
      <div class="icon"></div>
      <div class="text">{{indicatorItem.getLongAdvice(hasPurifier)}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailedModeExplanation',
  props: ['indicatorItem', 'hasPurifier'],
  computed: {
    isInOverflow() {
      return (
        this.indicatorItem && this.indicatorItem.getOverflowLevel() !== 'ok'
      )
    }
  }
}
</script>

<style lang="less">
@import '../app.less';

.detailed-mode-explanation-root {
  .desktop-media({max-width: 60vw;});

  margin: 0 1rem;
  font-size: @bigger-size;

  > .definition {
    line-height: 1.5rem;
    text-align: justify;
  }

  > .advice {
    margin-top: 0.5rem;
    display: flex;
    align-items: center;

    > .icon {
      margin: 0 1rem;
      flex-shrink: 0;
      width: @icon-size;
      height: @icon-size;
      background: url('../assets/advice.png') no-repeat;
      background-size: cover;
    }

    > .text {
      flex-grow: 1;
      margin-left: 0.5rem;
      font-weight: bold;
      text-align: justify;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DetailedModeExplanation.vue